export default "__VITE_ASSET__BeZhz9mh__"